const runGlobalScript = require('./modules/runGlobalScript')

require('jquery/jquery.validate')
runGlobalScript(require('legacy/jquery.cookie?raw'))
require('./Signup/newSignup')
require('./Login/testimonialCarousel')
